/// <amd-module name="Build/Pipelines/Tools/BuildReasonTools" />
import * as Resources from "Build/Pipelines/Resources";
import { BuildReason } from "Build/Client/Contracts/Build";


export function getReasonIcon(reason: BuildReason) {
    switch (reason) {
        case BuildReason.Manual:
            // Switch to "UserEvent" when it is available
            return "Contact";
        case BuildReason.Schedule:
            // Switch to "EventDate" when it is available
            return "Calendar";
        case BuildReason.PullRequest:
            return "BranchPullRequest";
        case BuildReason.BatchedCI:
        case BuildReason.IndividualCI:
            // Switch to final icon when it is decided
            return "Tag";
        case BuildReason.BuildCompletion:
            return "Build";
        default:
            return "Tag";
    }
}

export function getReasonText(reason: BuildReason, includeUser: boolean) {
    if (includeUser){
        switch (reason) {
            case BuildReason.Manual:
                return Resources.ReasonManualFor;
            case BuildReason.Schedule:
                return Resources.ReasonScheduleFor;
            case BuildReason.PullRequest:
                return Resources.ReasonPullRequestFor;
            case BuildReason.BatchedCI:
                return Resources.ReasonBatchedCIFor;
            case BuildReason.IndividualCI:
                return Resources.ReasonIndividualCIFor;
            case BuildReason.BuildCompletion:
                return Resources.ReasonBuildCompletionFor;
            case BuildReason.CheckInShelveset:
                return Resources.ReasonCheckInShelvesetFor;
            case BuildReason.ValidateShelveset:
                return Resources.ReasonValidateShelvesetFor;
            case BuildReason.ResourceTrigger:
                return Resources.ReasonResourceTriggerFor;
            default:
                return Resources.OtherReason;
        }
    }
    switch (reason) {
        case BuildReason.Manual:
            return Resources.ReasonManual;
        case BuildReason.Schedule:
            return Resources.ReasonSchedule;
        case BuildReason.PullRequest:
            return Resources.ReasonPullRequest;
        case BuildReason.BatchedCI:
            return Resources.ReasonBatchedCI;
        case BuildReason.IndividualCI:
            return Resources.ReasonIndividualCI;
        case BuildReason.BuildCompletion:
            return Resources.ReasonBuildCompletion;
        case BuildReason.CheckInShelveset:
            return Resources.ReasonCheckInShelveset;
        case BuildReason.ValidateShelveset:
            return Resources.ReasonValidateShelveset;
        case BuildReason.ResourceTrigger:
            return Resources.ReasonResourceTrigger;
        default:
            return Resources.OtherReason;
    }
}